import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';

// Подключаем необходимые плагины dayjs
dayjs.extend(weekday);
dayjs.extend(isoWeek);

export function getWeeksDates(startDate: dayjs.Dayjs) {
  const firstDayOfMonth = startDate.startOf('month');

  // Находим понедельник первой недели месяца
  const firstWeekMonday = firstDayOfMonth.isoWeekday(1);

  const lastDayOfMonth = startDate.endOf('month');

  // Находим воскресенье последней недели месяца
  const lastWeekSunday = lastDayOfMonth.isoWeekday(7).add(1, 'day');

  return {
    firstWeekMonday,
    lastWeekSunday,
  };
}
